import { getCareers } from 'helpers/api';
import { getUrlParamsByName, formatDate, throttleOrDie } from 'helpers/utils';

const state = {
  career: document.getElementsByClassName('js--career')[0],
  list: null,
  jobDescriptionUrl: null,
  job: null,
  sidebar: ['Title', 'Id', 'location', 'Department', 'CreatedDate', 'Openings', 'Priority'],
  descriptionContainer: null,
  iframeContainer: null,
  mobileIfrm: null,
  resizeTimer: null,
  descriptionTitle: null,
};

// ==================================================
// HANDLERS
// ==================================================

async function fetchAndHandleDetails() {

  const newtonId = getUrlParamsByName('gni')
  const id = parseInt(getUrlParamsByName('id'), 10)
  const { data, status } = await getCareers()

  if (status !== 200) {
    return;
  }

  if (!job) {
    job = data.filter((k) => k.Id == id)
  }
  job.CreatedDate = formatDate(job.CreatedDate)
  state.job = job
  state.job.location = `${state.job.City}, ${state.job.State}`
    ;[state.descriptionTitle] = document.getElementsByClassName('js--career-description-title')
  state.descriptionTitle.innerHTML = descriptionTitle(state.job.Title, state.job.location)

  if (state.mobileIfrm) {
    state.mobileIfrm.src = job.ApplyLink;
    window.addEventListener('resize', () =>
      throttleOrDie(state.resizeTimer, handleViewResize, 250),
    );
    return checkIfMobileWidth() ? handleViewResize() : false;
  }

  updateSidebar();
  state.descriptionContainer.innerHTML = state.job.Description;
  state.iframeContainer.src = state.job.ApplyLink;
}

function handleViewResize() {
  const height = parseInt(getComputedStyle(state.descriptionTitle).height, 10) + 35;

  state.mobileIfrm.style.height = `calc(100vh - ${height}px)`;
}

function updateSidebar() {
  state.sidebar.forEach((k) => {
    state.career.getElementsByClassName(`js--career-${k}`)[0].innerHTML = state.job[k];
  });
}

async function fetchAndHandleCareerList() {
  const { data, status } = await getCareers();

  if (status !== 200) {
    return
  }
  const newtonId = getUrlParamsByName('gni')
  let [job] = data.filter((k) => k.NewtonId == newtonId)
  if (job) {
    window.location = `${state.jobDescriptionUrl}?id=${job.Id}`
    return
  }

  state.list.innerHTML = data
    .map((k) => listItem({ ...k, url: `${state.jobDescriptionUrl}?id=${k.Id}` }))
    .join('');
}

function displayApplication(e) {
  e.preventDefault();

  const openNewTab = checkIfMobileWidth();

  if (openNewTab) {
    return window.open(e.target.href.concat(window.location.search), '_blank');
  }

  const { iframeContainer, descriptionContainer } = state;

  descriptionContainer.classList.add('none');
  iframeContainer.classList.remove('none');
  state.applyBtns.forEach((k) => k.classList.add('none'));
  window.scrollTo(0, 0);
}

// ==================================================
// HELPERS
// ==================================================

const checkIfMobileWidth = () => parseInt(getComputedStyle(state.career).width, 10) <= 960;

const descriptionTitle = (title, location) =>
  `<span class="career--bold">${title}</span><span> - </span>${location}`;

const listItem = ({ Title, City, url }) =>
  `<li class="career__item">
    <div class="career__item__detail">
      <p class="career__item__title">${Title}</p>
    </div>
    <div class="career__item__detail">
      <p class="career__item__location"><i class="fas fa-map-marker career__item__icon" aria-hidden="true"></i>${City}</p>
    </div>
    <div class="career__item__detail">
      <a href="${url}" class="career__item__view js--career-view"><i class="fas fa-search-plus career__item__icon" aria-hidden="true"></i>View Description</a>
    </div>
  </li>`;

// ==================================================
// INIT
// ==================================================

function init() {
  if (document.getElementsByClassName('js--career-info').length) {
    state.mobileIfrm = document.getElementsByClassName('js--career-mobile-iframe')[0] || null;
    state.applyBtns = Array.from(document.getElementsByClassName('js--career-apply'));
    [state.iframeContainer] = document.getElementsByClassName('js--career-iframe');
    [state.descriptionContainer] = document.getElementsByClassName('js--career-description');

    state.applyBtns.forEach((k) => k.addEventListener('click', (e) => displayApplication(e)));
    return fetchAndHandleDetails();
  }

  [state.list] = document.getElementsByClassName('js--career-list');
  state.jobDescriptionUrl = state.career.getAttribute('data-description');
  fetchAndHandleCareerList();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/career.js